import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

interface BrandLogoProps {
  name: string;
  logo: string;
}

export function BrandLogo({ name, logo }: BrandLogoProps) {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
    console.error(`Failed to load logo for ${name}:`, logo);
  };

  return (
    <div className="h-16 flex items-center justify-center px-4 transition-transform hover:scale-105">
      {hasError ? (
        <div className="flex flex-col items-center justify-center text-gray-400">
          <ImageOff className="w-8 h-8 mb-1" />
          <span className="text-xs">{name}</span>
        </div>
      ) : (
        <img
          src={logo}
          alt={`${name} logo`}
          className={`max-h-10 w-auto object-contain transition-opacity duration-300 ${
            isLoading ? 'opacity-0' : 'opacity-100'
          }`}
          loading="lazy"
          onError={handleImageError}
          onLoad={handleImageLoad}
        />
      )}
    </div>
  );
}